// hooks/useDeckSession.js
import { useEffect, useState } from "react";
import { doc, onSnapshot, updateDoc, setDoc } from "firebase/firestore";
import { db } from "../auth/auth";

export function useDeckSession(deckId) {
  const [session, setSession] = useState({
    currentSlideId: null,
    adminScrollY: 0,
    loading: true,
  });

  useEffect(() => {
    if (!deckId) return;
    const sessionRef = doc(db, "sessions", deckId);  //one deck = one session

    const unsubscribe = onSnapshot(sessionRef, (snap) => {
      console.log("FIREBASE: GET => Session data received.");
      if (snap.exists()) {
        setSession({ ...snap.data(), loading: false });
      } else {
        // Initialize if session document doesn't exist yet
        setDoc(sessionRef, { 
          currentSlideId: "slide_1", 
          adminScrollY: 0, 
          updatedAt: Date.now() 
        });
      }
    });
    return () => unsubscribe();
  }, [deckId]);

  const updateSession = async (patch) => {
    if (!deckId) return;
    console.log('FIREBASE: POST',  patch);
    const sessionRef = doc(db, "sessions", deckId);
    await updateDoc(sessionRef, { ...patch, updatedAt: Date.now() });
  };

  return { ...session, updateSession };
}